import constants from "../constants";
import {getHeaders} from "./global";
import axios from "axios"

const MOCKED_ENDPOINT = {
	"id": "b7021ac1-ec53-4d30-98cc-81c655e60ad5",
	"last_check": "2019-09-21T21:01:52",
	"enabled": true,
	"results": [{
			"date": "2019-09-01T20:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-01T22:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 0
		},
		{
			"date": "2019-09-01T00:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-02T04:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 2
		},
		{
			"date": "2019-09-02T08:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-02T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-03T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-03T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-03T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 0
		},
		{
			"date": "2019-09-04T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-04T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-04T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-05T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-05T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 2
		},
		{
			"date": "2019-09-05T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-06T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-06T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-06T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-07T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		},
		{
			"date": "2019-09-07T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 0
		},
		{
			"date": "2019-09-07T12:01:52",
			"response_status": 200,
			"response_time": 210,
			"response_body": {},
			"status": 1
		}
	]
}

function getEndpoints(){
	return axios.get(
        constants.API_URL + "apitests/",
        getHeaders()
    )
}

function createEndpoint(payload){
	return axios.post(
        constants.API_URL + "apitests/",
        payload,
        getHeaders()
    )
}


function getEndpoint(endpoint_id){
    return axios.get(
        constants.API_URL + "apitests/" + endpoint_id + "/",
        getHeaders()
    )
}

function updateEndpoint(endpoint_id, payload){
    return axios.patch(
		constants.API_URL + "apitests/" + endpoint_id + "/",
		payload,
        getHeaders()
    )
}


function intervalToText(interval){
	return constants.INTERVAL_TO_TEXT[interval]
}


function getAPITestGraph(apitest_id){
    return axios.get(
        constants.API_URL + "apitests/" + apitest_id + "/graph/",
        getHeaders()
    )
}


function checkAPITest(apitest_id){
    return axios.post(
		constants.API_URL + "apitests/" + apitest_id + "/check/",
		{},
        getHeaders()
    )
}


export {
	getEndpoint,
	getEndpoints,
	createEndpoint,
	intervalToText,
	getAPITestGraph,
	checkAPITest,
	updateEndpoint,
}
